import React, { useEffect, useRef } from 'react';

const TextComponent = ({ content, onUpdate, autoFocus = false }) => {
  const textareaRef = useRef(null);

  useEffect(() => {
    if (!autoFocus) return;
    const focusTextArea = () => {
      const textarea = textareaRef.current;
      if (!textarea) return;
      textarea.focus({ preventScroll: true });
      const end = textarea.value.length;
      textarea.setSelectionRange(end, end);
    };
    const frameId = window.requestAnimationFrame(focusTextArea);
    return () => window.cancelAnimationFrame(frameId);
  }, [autoFocus]);

  const handleContentChange = (event) => {
    onUpdate({ content: event.target.value });
  };

  return (
    <div className="wb-text-block">
      <textarea
        ref={textareaRef}
        className="wb-text-block__textarea"
        value={content || ''}
        onChange={handleContentChange}
        placeholder="Start typing..."
        onMouseDown={(event) => event.stopPropagation()}
        onClick={(event) => event.stopPropagation()}
      />
    </div>
  );
};

export default React.memo(TextComponent);
